export const bg = "var(--seed-color-manner-temp-l5-bg)";
export const text = "var(--seed-color-manner-temp-l5-text)";